import { ApiService } from '../../services/api.service';
import { AuthenticationService } from "../../services/authentication.service";
import { TemplateService } from '../../services/template.service';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CALENDAR_LOCALE } from '../../services/constant';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from '@ngx-translate/core';
var SearchComponent = (function () {
    function SearchComponent(apiService, authService, modalService, template, translate) {
        this.apiService = apiService;
        this.authService = authService;
        this.modalService = modalService;
        this.template = template;
        this.translate = translate;
        this.itemsPerPage = 40;
        this.allDeliverycode = true;
        this.allDocType = true;
        this.allDeliverycodeList = null;
        this.deliverycodeList = null;
        this.docTypeList = null;
        this.allDocumentType = [];
        this.allDeliverycodeSelected = [];
        this.startDate = null;
        this.endDate = null;
        this.totalItems = 0;
        this.selectedValues = [];
        this.selectedForShow = [];
        this.currentPage = 1;
        this.checked = false;
        this.loading = false;
        this.loadingZip = false;
        this.errorMsg = '';
        this.sendEmailSmsValues = [];
        this.defaultLabel = null;
        this.checkAll = false;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.loading_all_zip = false;
        this.cancel_loading_all_zip = false;
        this.loading_all_zip_message = '';
        this.loading_all_zip_progress = 0;
        this.tableArray = [];
        this.allZipCurrent = 0;
        this.tableCol = [
            { field: 'invoice_number', header: 'เลขที่เอกสาร' },
            { field: 'header_issue_date', header: 'วันที่ออกเอกสาร' },
            { field: 'branch', header: 'ชื่อสาขา' },
            { field: 'rd_doc_type', header: 'ประเภทเอกสาร' },
            // { field: 'buyer_name', header: 'ชื่อผู้ซื้อ' },
            { field: 'total_items_total_payment', header: 'ยอดขาย' }
        ];
    }
    SearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.onLangChange.subscribe(function (event) {
            _this.loadTexts();
        });
        this.loadTexts();
        // this.loadInput();
        // this.loadDropdown();
        this.rdDocumentType = this.template.getDropdown();
    };
    SearchComponent.prototype.loadTexts = function () {
        var _this = this;
        this.defaultLabel = this.translate.instant('COMMON.ALL');
        this.tableCol = [];
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.translate.get('COMMON.ALL').subscribe(function (res) {
            var documentTypeData = _this.template.getDropdown();
            // documentTypeData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};
            _this.rdDocumentType = documentTypeData;
            _this.loadInput();
            _this.tableCol.push({ field: 'customer_code', header: _this.translate.instant('FILTER.CUSTOMER-CODE') }, { field: 'delivery_code', header: _this.translate.instant('FILTER.DELIVERY-CODE') }, { field: 'header_issue_date', header: _this.translate.instant('FILTER.DATE-OF-ISSUE') }, { field: 'invoice_number', header: _this.translate.instant('FILTER.DOCUMENT-NUMBER') }, { field: 'goods_issue_number', header: _this.translate.instant('FILTER.GOODS-ISSUE-NUMBER') }, { field: 'branch', header: _this.translate.instant('TABLE.BRANCH-NAME') }, { field: 'rd_doc_type', header: _this.translate.instant('FILTER.DOCUMENT-TYPE') }, 
            // { field: 'buyer_name', header: 'ชื่อผู้ซื้อ' },
            { field: 'total_items_total_payment', header: _this.translate.instant('TABLE.SALES') }, { field: 'latest_sent_time', header: _this.translate.instant('FILTER.LATEST-SENT') });
            _this.tableCol = _.uniqBy(_this.tableCol, 'field');
        });
    };
    SearchComponent.prototype.loadInput = function () {
        var _this = this;
        this.selectedCustomercode = null;
        this.customercode = null;
        this.selectedRdDocumentType = null;
        this.customercode = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        var params = new HttpParams();
        params = params.append('none_pagination', 'true');
        this.apiService.getCustomerList(params).subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.customercode.push({
                    label: obj.c_code + " (" + obj.c_name + ")",
                    value: obj.id
                });
            });
            _this.customercode = _.uniqBy(_this.customercode, 'label');
        }, function (error) { return error(status); });
        this.homeproGroup = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompanyGroup().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.homeproGroup.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        });
        this.apiService.getDeliveryList().subscribe(function (result) {
            _this.allDeliverycodeList = result;
            _this.filterDeliverycodeList();
        });
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.endDate = new Date();
    };
    Object.defineProperty(SearchComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (2020 - 1) + ':' + (thisYear);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    SearchComponent.prototype.filterDeliverycodeList = function () {
        var _this = this;
        this.selectedDeliverycode = null;
        this.deliverycodeList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allDeliverycodeList, function (obj) {
            if (_this.selectedCustomercode == null || obj.d_custcode == _this.selectedCustomercode)
                _this.deliverycodeList.push({
                    label: obj.d_code,
                    value: obj.id
                });
        });
    };
    SearchComponent.prototype.searchDeliverycode = function (event) {
        var _this = this;
        if (this.deliverycodeList == null) {
            this.apiService.getDeliveryList().subscribe(function (data) {
                _this.deliverycodeList = data;
                _this.deliverycodeSuggest = _this.filterData(event.query, 'd_code', _this.deliverycodeList);
            });
        }
        else {
            this.deliverycodeSuggest = this.filterData(event.query, 'd_code', this.deliverycodeList);
        }
    };
    SearchComponent.prototype.searchDocumentType = function (event) {
        var _this = this;
        if (this.docTypeList == null) {
            this.apiService.getDocumentType().subscribe(function (result) {
                _this.docTypeList = result;
                _this.typeSuggest = _this.filterData(event.query, 'type', _this.docTypeList);
            });
        }
        else {
            this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        }
    };
    SearchComponent.prototype.selectAllDeliverycode = function () {
        this.deliverycode = null;
    };
    SearchComponent.prototype.selectDocType = function () {
        this.documentType = null;
    };
    SearchComponent.prototype.clearDeliverycode = function () {
        this.allDeliverycodeSelected = [];
    };
    SearchComponent.prototype.clearDocType = function () {
        this.allDocumentType = [];
    };
    SearchComponent.prototype.filterData = function (query, field, dataList) {
        query = query.toLowerCase().trim();
        var filtered = [];
        for (var i = 0; i < dataList.length; i++) {
            var data = dataList[i];
            if (data[field].toLowerCase().indexOf(query) >= 0) {
                filtered.push(data);
            }
        }
        return filtered;
    };
    SearchComponent.prototype.loadDropdown = function () {
        this.docTypes = this.template.getDropdown();
    };
    SearchComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.checkAll = false;
        this.loadData(params);
    };
    SearchComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    SearchComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    SearchComponent.prototype.clearSearch = function () {
        this.selectedType = null;
        this.inputText = null;
        this.selectedCustomercode = null;
        this.selectedHomeproGroup = null;
        this.deliverycode = null;
        this.documentType = null;
        this.allDocType = true;
        this.allDeliverycode = true;
        this.selectedDeliverycode = null;
        this.rdDocumentType = null;
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.endDate = new Date();
        this.searchButtonClicked();
    };
    SearchComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.loadData();
    };
    SearchComponent.prototype.loadData = function (params) {
        var _this = this;
        this.checkCondition();
        if (this.errorMsg.length > 0)
            return;
        this.allDeliverycodeSelected = [];
        this.allDocumentType = [];
        _.forEach(this.deliverycode, function (data) {
            // this.allBranchSelected = [];
            _this.allDeliverycodeSelected.push(_.toNumber(data.id));
        });
        _.forEach(this.documentType, function (data) {
            // this.allDocumentType = [];
            _this.allDocumentType.push(_.toNumber(data.id));
        });
        var data = {
            rd_doc_type: this.selectedRdDocumentType,
            search_box: this.inputText,
            header_issue_date_start: this.startDate == null ? this.startDate : moment(this.startDate).format('YYYY-MM-DD'),
            header_issue_date_end: this.endDate == null ? this.endDate : moment(this.endDate).format('YYYY-MM-DD'),
            group_id: this.selectedHomeproGroup,
            customercode_id: this.selectedCustomercode,
            document_type_id: (_.isNil(this.documentType)) ? this.documentType : _.uniq(this.allDocumentType),
            //branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
            // deliverycode_id: this.selectedDeliverycode ? [this.selectedDeliverycode] : null,
            deliverycode_id: this.selectedDeliverycode ? this.selectedDeliverycode : null,
            items_per_page: this.itemsPerPage
        };
        if (this.sortBy && this.sortMode) {
            data['sort'] = this.sortBy;
            data['sort_type'] = this.sortMode;
        }
        this.loading = true;
        this.apiService.postSearch(data, params).subscribe(function (res) {
            res.results = _.orderBy(res.results, ['header_issue_dt', function (o) {
                    if (o.rd_document_type === 'receipt') {
                        return 1;
                    }
                    if (o.rd_document_type === 'tax_invoice') {
                        return 0;
                    }
                    if (o.rd_document_type === 'credit_note') {
                        return 2;
                    }
                    if (o.rd_document_type === 'debit_note') {
                        return 3;
                    }
                }], ['desc', 'asc']);
            _this.tableData = res.results;
            _this.totalItems = res.count;
            _this.selectedValues = [];
            _this.sendEmailSmsValues = [];
            for (var i = 0; i < _this.tableData.length; i++) {
                _this.selectedValues.push(false);
            }
            _this.loading = false;
        });
    };
    SearchComponent.prototype.sendEmail = function (email_id, index) {
        var _this = this;
        this.loading = true;
        var data = {
            'tax_id': email_id
        };
        console.log('send');
        this.apiService.send_email_web(data).subscribe(function (res) {
            console.log(res);
            if (res === 'OK') {
                _this.tableData[index].emailtosend_taxdata_id = null;
                _this.loading = false;
            }
            else {
                _this.loading = false;
            }
            _this.searchButtonClicked();
        }, function (error) {
            console.log('this is error', error);
        });
        this.searchButtonClicked();
    };
    SearchComponent.prototype.DownloadSelected = function (content, doc_type) {
        this.tableArray = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i])
                continue;
            this.tableArray.push(this.tableData[i]);
        }
        if (!_.isEmpty(this.tableArray)) {
            this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
            this.allZipCount = this.tableArray.length;
            this.cancel_loading_all_zip = false;
            if (doc_type === 'xml')
                this.download(0, this.tableArray, 'xml_file');
            else
                this.download(0, this.tableArray, 'pdf_file');
        }
    };
    SearchComponent.prototype.EnabledDownloadSelected = function () {
        return this.selectedValues.filter(function (select) { return select == true; }).length > 0;
    };
    SearchComponent.prototype.download = function (index, tableArray, url_field_name) {
        var _this = this;
        this.loading_all_zip = true;
        if (index >= tableArray.length) {
            this.loading_all_zip = false;
            this.loading_all_zip_message = 'Download ' + this.translate.instant('COMMON.COMPLETE') + ' (' + this.translate.instant('FILTER.ALL') + ' ' + tableArray.length + ' ' + this.translate.instant('COMMON.ITEMS') + ')';
            return;
        }
        if (this.cancel_loading_all_zip) {
            return;
        }
        var download_url = tableArray[index][url_field_name];
        //skip if download url is empty.
        if (download_url == null || download_url.length == 0) {
            this.download(index + 1, tableArray, url_field_name);
            return;
        }
        this.apiService.downloadFileFromMediaPath(download_url).subscribe(function (obj) {
            if (_this.cancel_loading_all_zip) {
                return;
            }
            // this.loading_all_zip = false;
            var filename = _this.getFileName(tableArray[index]);
            if (url_field_name == 'xml_file')
                filename = filename + '.xml';
            else
                filename = filename + '.pdf';
            _this.apiService.createDownloadFile(obj, filename);
            _this.allZipCurrent++;
            _this.loading_all_zip_progress = (_this.allZipCurrent / _this.allZipCount) * 100;
            // data.xmlLoading = false;
            setTimeout(function () {
                _this.download(index + 1, tableArray, url_field_name);
            }, 1000);
            // tslint:disable-next-line:max-line-length
            _this.apiService.triggerLog({ 'log_type': 'DOWNLOAD_PDF', 'action_issue': 'DOCUMENT_SEARCH', 'description': "download " + url_field_name + " invoice number " + tableArray[index].header_invoice_number }).subscribe();
        }, function (error) {
            _this.loading_all_zip = false;
            _this.loading_all_zip_message = _this.translate.instant('ERROR.TRY-AGAIN');
            // data.xmlLoading = false;
        });
    };
    SearchComponent.prototype.closeDownloadAll = function () {
        this.modal.close();
        this.cancel_loading_all_zip = true;
        this.loading_all_zip = false;
        this.allZipCurrent = 0;
        this.loading_all_zip_progress = 0;
    };
    SearchComponent.prototype.getFileName = function (data) {
        var file_name = '' + data.header_invoice_number + '_' + data.rd_document_type + '_' + data.header_issue_dt;
        file_name = file_name.replace(/([^a-z0-9]+)/gi, '_');
        return file_name;
    };
    SearchComponent.prototype.selectDeselectAll = function (checked) {
        if (checked) {
            this.selectAll();
            this.checkAll = true;
            return;
        }
        this.deselectAll();
        this.checkAll = false;
    };
    SearchComponent.prototype.selectAll = function () {
        for (var i = 0; i < this.tableData.length; i++) {
            this.selectedValues[i] = true;
        }
    };
    SearchComponent.prototype.deselectAll = function () {
        for (var i = 0; i < this.tableData.length; i++) {
            this.selectedValues[i] = false;
        }
    };
    SearchComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'desc';
        }
        else {
            this.sortMode = 'asc';
        }
    };
    SearchComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    SearchComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.deliverycode) && this.allDeliverycode === false) {
            errorMsgList.push(this.translate.instant('FILTER.DELIVERY-CODE'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' + this.translate.instant('COMMON.CORRECT');
            return;
        }
        var dayDiff = Math.abs(moment(this.endDate).diff(moment(this.startDate), 'days'));
        if (dayDiff > 60 && this.authService.isAccountant()) {
            this.errorMsg = this.translate.instant('FILTER.ERROR.DIFF');
        }
    };
    return SearchComponent;
}());
export { SearchComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search.component.ts.pre-build-optimizer.js